routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.paymentBills', {
      url: "/pagos-y-anticipos/facturas",
      template: `<payment-bills sh-ctrl="shCtrl"></payment-bills>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-bills/payment-bills.config.js
 **/